import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import uuid4 from 'uuid';
import { FontAwesomeIcon as FAIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import Photo from './Photo';
import Spinner from '../../Spinner/Spinner';
import { imgix } from '../../../lib/env';

const { imgix_domain, s3_domain_to_replace, imgix_parameters_student } = imgix;

const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 0.5rem;

  ${props => props.limit
    && css`
      max-height: 60vh;
      overflow: scroll;
      -webkit-overflow-scrolling: touch;
      padding: 0.5rem;
    `};
`;

const Container = styled.div`
  display: grid;
  grid-template-rows: 1fr auto;
  grid-gap: 1.5rem;
`;

const Refresh = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 0.5rem;

  svg {
    cursor: pointer;
    font-size: 1.5rem;
    color: orange;
  }
`;

const Message = styled.p`
  color: var(--font-color-faded);

  ${props => props.error
    && `
    color: var(--color-red);
    filter: opacity(0.7),
  `}
`;

const getPhotoFilename = (path) => {
  const splitPath = path.split('/');

  return splitPath[splitPath.length - 1];
};

const StudentContent = ({
  student, getStudentsPhotos, studentId, handleDelete,
}) => {
  const { data, fetching, error } = student;
  const [photos, setPhotos] = useState([]);

  const photosEmpty = data.length === 0;
  const photosLong = data.length > 6;

  useEffect(() => {
    getStudentsPhotos(studentId);
  }, []);

  useEffect(() => {
    if (data.length !== photos.length) {
      setPhotos(data);
    }
  }, [data]);

  return (
    <Container>
      <Refresh>
        <FAIcon icon={faSync} onClick={() => getStudentsPhotos(studentId)} />
      </Refresh>
      <Content limit={photosLong}>
        {fetching && <Spinner big />}
        {!photosEmpty
          && !fetching
          && photos.map((photo) => {
            const filename = getPhotoFilename(photo.attributes.url);
            const src = photo.attributes.url;
            return (
              <Photo
                key={uuid4()}
                src={src.replace(s3_domain_to_replace, imgix_domain) + imgix_parameters_student}
                handleDelete={() => handleDelete(studentId, filename, photo.id)}
              />
            );
          })}
        {photosEmpty && !fetching && !error && (
          <Message>Diesem Schüler wurden noch keine Fotos zugewiesen.</Message>
        )}
        {error && <Message error>Es ist ein Fehler aufgetreten.</Message>}
      </Content>
    </Container>
  );
};

export default StudentContent;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Student/StudentContent.jsx